import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export function MemberBillingPlaceholder() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Admin access required</CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-sm text-muted-foreground">
          Billing is managed by organization admins. Contact your organization
          admin to upgrade, view invoices, or change your plan.
        </p>
      </CardContent>
    </Card>
  );
}
